module.exports = __webpack_public_path__ + "img/okey.e930e402.png";